// extracted by mini-css-extract-plugin
export default {"container":"aU-z","topReviewHeading":"bU-z","criticalReview":"cU-z","favorableReview":"dU-z","vsSeparator":"eU-z"};